import PropTypes from 'prop-types'
import { AnimatePresence, motion } from 'framer-motion'

import { useReducedMotionPreference, DURATION, EASE_IN_OUT } from '../../../styles/motion'

// Spec §8 "Inline reveal" — opacity 0→1, translateY −6→0, scaleY .92→1, 320ms ease-in-out,
// origin top. Used for the account-name banner, inline field errors, and the V2-style
// inline reveals generally (e.g. a sheet handing off into its next screen's new content).
const Reveal = ({ show, children }) => {
  const reduceMotion = useReducedMotionPreference()

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          style={{ transformOrigin: 'top' }}
          initial={reduceMotion ? false : { opacity: 0, y: -6, scaleY: 0.92 }}
          animate={{ opacity: 1, y: 0, scaleY: 1 }}
          exit={reduceMotion ? undefined : { opacity: 0, y: -6, scaleY: 0.92 }}
          transition={{ duration: DURATION.inlineReveal, ease: EASE_IN_OUT }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

Reveal.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node,
}

export default Reveal
